import React from 'react'
import Form from 'react-bootstrap/Form'
import './ATRadioButton.css'

interface ATRadioButtonProps {
  id: string
  label: string
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  selectedValue: string
  checked?: boolean
  subContent?: string | React.ReactNode
  name: string
}

const ATRadioButton = ({
  id,
  label,
  handleChange,
  disabled,
  selectedValue,
  checked = false,
  subContent,
  name,
}: ATRadioButtonProps) => {
  return (
    <>
      <Form.Check
        type="radio"
        id={id}
        label={label}
        aria-label={label}
        disabled={disabled}
        onChange={handleChange}
        value={selectedValue}
        checked={checked}
        name={name}
      ></Form.Check>
      {subContent && <label className="radioLabel">{subContent}</label>}
    </>
  )
}

export default ATRadioButton
